import Rest from '@/services/Rest'

export default class ProcedureAndPatientDetailService extends Rest {
  /**
   * @type {String}
   */
  static resource = '/procedureAndPatientDetails'

}
